module.exports = __webpack_public_path__ + "img/circle-5.3ecd52dd.svg";